import React from 'react';
import ActionsMenu from "./ActionsMenu";

const TableRow = ({
  rowIndex,
  row,
  headers,
  rowActions,
  showCheckbox,
  isSelected,
  onCheckboxChange,
}) => {
  const getRowBgColor = (index) => (index % 2 === 0 ? "#fff" : "#f7f7fa");

  return (
    <tr style={{ backgroundColor: getRowBgColor(rowIndex) }}>
      {showCheckbox && (
        <td
          style={{
            padding: "16px 12px",
            verticalAlign: "middle",
            borderBottom: "1px solid #eee"
          }}
        >
          <input
            type="checkbox"
            checked={isSelected}
            onChange={() => onCheckboxChange(rowIndex)}
          />
        </td>
      )}
      {headers.map((header) => (
        <td
          key={header.key}
          style={{
            padding: "16px 12px",
            fontFamily: "inherit",
            fontSize: 16,
            cursor: "pointer",
            textAlign: "left",
            verticalAlign: "middle",
            borderBottom: "1px solid #eee"
          }}
        >
          {row[header.key]}
        </td>
      ))}
      {rowActions && Object.keys(rowActions).length > 0 && (
        <td style={{ padding: 0 }}>
          <ActionsMenu
            actions={Object.entries(rowActions).map(([actionName, actionHandler]) => ({
              label: actionName.charAt(0).toUpperCase() + actionName.slice(1),
              onClick: () => actionHandler(row),
            }))}
          />
        </td>
      )}
    </tr>
  );
};

export default TableRow;
